module.exports = __webpack_public_path__ + "b95aa56b837920dbda7085de53699d3b.pdf";